declare const __FEATURES__: Feature[]
type Feature =
  | 'autotests'
  | 'log'
  | 'redux_remote'
  | 'public_spending_trend_filter'
  | 'actions'
  | 'app'
  | 'with-credit-card'

/**
 * The format is `?featureName=on` or `?featureName=true` or
 * `?featureName=off` or `?featureName=false`
 */
const getFeaturesFromUrl = (configFeatures: Feature[]): Feature[] => {
  let features: Feature[] = [...configFeatures]
  const params = new URLSearchParams(window.location.search)

  params.forEach((value, key) => {
    if (['true', 'on'].includes(value)) {
      features.push(key as Feature)
    }
    if (['false', 'off'].includes(value)) {
      features = features.filter((feature) => feature !== key)
    }
  })

  return features
}

const FEATURES = new Set(getFeaturesFromUrl(__FEATURES__))

export const isFeatureEnabled = (feature: Feature) => FEATURES.has(feature)
